"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountriesSuggestions = exports.getCitiesiesSuggestions = exports.trackMovingInRequest = exports.createMovingInRequest = exports.anyMeterByRegistrationNumber = exports.anyMeterBySerialNumber = exports.fetchMetersByAddress = exports.fetchWaterChargeByCommuneInseeCode = exports.checkCommuneEligibility = exports.getDeliveryPointAddress = exports.getEstimatedMonthlyPaiement = exports.subscribe = exports.getCommuneSuggestion = void 0;
var axiosInstance_1 = __importDefault(require("../helper/axiosInstance"));
var index_1 = require("../index");
var waterCharge_1 = __importDefault(require("../models/waterCharge"));
function getCommuneSuggestion(address) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    route = "/communes?searchWord=";
                    fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route).concat(address);
                    return [4 /*yield*/, axiosInstance_1.default.get(fullpath)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.getCommuneSuggestion = getCommuneSuggestion;
function checkCommuneEligibility(address) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath;
        return __generator(this, function (_a) {
            if (!index_1.urlsConfig.values)
                throw Error("No urls config found");
            route = "/communes/insee_code/";
            fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route).concat(address);
            return [2 /*return*/, axiosInstance_1.default.get(fullpath)];
        });
    });
}
exports.checkCommuneEligibility = checkCommuneEligibility;
function subscribe(form) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var config, route, fullpath, bodyFormData, formToBeSent, _d, _, accountHolderWoAttachment, _e, _, jointAccountHolderWoAttachment, _f, _, meterWoAttachment, blob, MovingInRequestJson, accountHolderFileExtension, accountHolderFileName, jointAccountHolderFileExtension, jointAccountHolderFileName, meterIndexFileExtension, meterIndexFileName;
        return __generator(this, function (_g) {
            config = {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "multipart/form-data",
                }
            };
            if (!index_1.urlsConfig.values)
                throw Error("No urls config found");
            route = "/imovein";
            fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
            bodyFormData = new FormData();
            formToBeSent = __assign({}, form);
            if (!!form.accountHolder) {
                _d = form.accountHolder, _ = _d.attachment, accountHolderWoAttachment = __rest(_d, ["attachment"]);
                formToBeSent.accountHolder = accountHolderWoAttachment;
            }
            if (!!form.jointAccountHolder) {
                _e = form.jointAccountHolder, _ = _e.attachment, jointAccountHolderWoAttachment = __rest(_e, ["attachment"]);
                formToBeSent.jointAccountHolder = jointAccountHolderWoAttachment;
            }
            if (!!form.meter) {
                _f = form.meter, _ = _f.attachment, meterWoAttachment = __rest(_f, ["attachment"]);
                formToBeSent.meter = meterWoAttachment;
            }
            blob = new Blob([JSON.stringify(formToBeSent)], { type: "application/json" });
            MovingInRequestJson = new File([blob], 'MovingInRequestJson.json');
            bodyFormData.append('MovingInRequestFile', MovingInRequestJson);
            if (!!((_a = form.accountHolder) === null || _a === void 0 ? void 0 : _a.attachment)) {
                accountHolderFileExtension = form.accountHolder.attachment.name.split('.').pop();
                accountHolderFileName = "AccountHolderAttachment.".concat(accountHolderFileExtension);
                bodyFormData.append('AccountHolderAttachment', form.accountHolder.attachment, accountHolderFileName);
            }
            if (!!((_b = form.jointAccountHolder) === null || _b === void 0 ? void 0 : _b.attachment)) {
                jointAccountHolderFileExtension = form.jointAccountHolder.attachment.name.split('.').pop();
                jointAccountHolderFileName = "JointAccountHolderAttachment.".concat(jointAccountHolderFileExtension);
                bodyFormData.append('JointAccountHolderAttachment.', form.jointAccountHolder.attachment, jointAccountHolderFileName);
            }
            if (!!((_c = form.meter) === null || _c === void 0 ? void 0 : _c.attachment)) {
                meterIndexFileExtension = form.meter.attachment.name.split('.').pop();
                meterIndexFileName = "MeterIndexAttachment.".concat(meterIndexFileExtension);
                bodyFormData.append('MeterIndexAttachment', form.meter.attachment, meterIndexFileName);
            }
            return [2 /*return*/, axiosInstance_1.default.post(fullpath, bodyFormData, config)];
        });
    });
}
exports.subscribe = subscribe;
function getEstimatedMonthlyPaiement(consumptionForm) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath;
        return __generator(this, function (_a) {
            if (!index_1.urlsConfig.values)
                throw Error("No urls config found");
            route = "/consumption_estimation";
            fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
            return [2 /*return*/, axiosInstance_1.default.post(fullpath, consumptionForm)];
        });
    });
}
exports.getEstimatedMonthlyPaiement = getEstimatedMonthlyPaiement;
function fetchWaterChargeByCommuneInseeCode(inseeCode) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    route = "/communes/".concat(inseeCode, "/water_charge");
                    fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(fullpath)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, new waterCharge_1.default(response.data)];
            }
        });
    });
}
exports.fetchWaterChargeByCommuneInseeCode = fetchWaterChargeByCommuneInseeCode;
function getDeliveryPointAddress(meterSerialNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    route = "/deliverypoint/".concat(meterSerialNumber, "/address");
                    fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(fullpath)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
            }
        });
    });
}
exports.getDeliveryPointAddress = getDeliveryPointAddress;
function fetchMetersByAddress(zipCode, streetAddress, residenceNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    route = "/address/meters?zipCode=".concat(zipCode, "&streetAddress=").concat(streetAddress, "&number=").concat(residenceNumber);
                    fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(fullpath)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.fetchMetersByAddress = fetchMetersByAddress;
function anyMeterBySerialNumber(meterSerialNumber, inseeCode) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath;
        return __generator(this, function (_a) {
            if (!index_1.urlsConfig.values)
                throw Error("No urls config found");
            route = "/meter/serial_number/".concat(meterSerialNumber, "/insee_code/").concat(inseeCode, "/any");
            fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
            return [2 /*return*/, axiosInstance_1.default.get(fullpath)];
        });
    });
}
exports.anyMeterBySerialNumber = anyMeterBySerialNumber;
function anyMeterByRegistrationNumber(meterRegistrationNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath;
        return __generator(this, function (_a) {
            if (!index_1.urlsConfig.values)
                throw Error("No urls config found");
            route = "/meter/registration_number/".concat(meterRegistrationNumber, "/any");
            fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
            return [2 /*return*/, axiosInstance_1.default.get(fullpath)];
        });
    });
}
exports.anyMeterByRegistrationNumber = anyMeterByRegistrationNumber;
function createMovingInRequest(movingInRequest, captchaToken) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, fullpath, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    if (captchaToken) {
                        config = {
                            headers: {
                                "Content-Type": "application/json",
                                "g-recaptcha-response": captchaToken,
                            },
                        };
                    }
                    else {
                        config = {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        };
                    }
                    route = "/move_in/request";
                    fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.post(fullpath, movingInRequest, config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.createMovingInRequest = createMovingInRequest;
function trackMovingInRequest(movingInRequest) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath;
        return __generator(this, function (_a) {
            if (!index_1.urlsConfig.values)
                throw Error("No urls config found");
            route = "/move_in/request";
            fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
            return [2 /*return*/, axiosInstance_1.default.put(fullpath, movingInRequest)];
        });
    });
}
exports.trackMovingInRequest = trackMovingInRequest;
function getCountriesSuggestions() {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    route = "/clients/countries";
                    fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(fullpath)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.getCountriesSuggestions = getCountriesSuggestions;
function getCitiesiesSuggestions(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var route, fullpath, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error("No urls config found");
                    route = "/clients/get_dqe_cities?isoCountryCode=".concat(payload.countryCode, "&city=").concat(payload.city);
                    fullpath = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(fullpath)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.getCitiesiesSuggestions = getCitiesiesSuggestions;
